import React from 'react';

const metrics = [
  { value: '73%', label: 'Fewer bad hires' },
  { value: '$240K', label: 'Cost per bad hire' },
  { value: '89%', label: 'Prediction accuracy' },
  { value: '15min', label: 'Results time' }
];

const HomeTractionMetrics = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="text-center animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="text-5xl md:text-6xl font-bold text-gray-900 mb-2" style={{ letterSpacing: '-0.03em' }}>
                {metric.value}
              </div>
              <div className="text-gray-600 font-medium">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTractionMetrics;
